module.exports = __webpack_public_path__ + "media/deposit.85cadaaa.mp3";